import { render } from "./HeadForm.vue?vue&type=template&id=450fa865&scoped=true"
import script from "./HeadForm.vue?vue&type=script&lang=js"
export * from "./HeadForm.vue?vue&type=script&lang=js"

import "./HeadForm.vue?vue&type=style&index=0&id=450fa865&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450fa865"]])

export default __exports__